exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".star-rating-container {\n  display: grid;\n  grid-template-columns: repeat(5, 15px);\n  grid-template-rows: 15px;\n  position: relative;\n  width: 75px; }\n  .star-rating-container__item {\n    cursor: pointer;\n    fill: white;\n    height: 15px;\n    width: 15px; }\n    .star-rating-container__item--active {\n      fill: #EB4E7A; }\n  .star-rating-container-warning {\n    background-color: rgba(255, 0, 0, 0.7);\n    color: #fff;\n    font-weight: bold;\n    left: -2rem;\n    padding: .5rem;\n    position: absolute;\n    top: 1.5rem;\n    width: 200px; }\n    .star-rating-container-warning--hide {\n      display: none; }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"importLoaders":1}!./node_modules/postcss-loader/lib?{"ident":"postcss","plugins":[null,null]}!./node_modules/sass-loader/lib/loader.js!./src/components/StarRating/StarRating.scss
// module id = 213
// module chunks = 0